import { T } from "../../../../localization";
import * as React from "react";
import { getAccountInfo, updateEmailPreferences } from "../../../../api/rest-apis";

interface PersonalProps {}

interface PersonalState {
  firstName: string;
  lastName: string;
  email: string;
  provider: string;
  unsubscribed: boolean;
  isUpdatingPreference: boolean;
  isLoadingAccount: boolean;
  preferenceError: boolean;
}

class Personal extends React.Component<PersonalProps, PersonalState> {
  state: PersonalState = {
    firstName: "", lastName: "", email: "", provider: "",
    unsubscribed: false, isUpdatingPreference: false, isLoadingAccount: true, preferenceError: false,
  };

  componentDidMount() {
    this.getAccountInfo();
  }

  async getAccountInfo() {
    try {
      const response: any = await getAccountInfo();
      this.setState({
        firstName: response.firstName,
        lastName: response.lastName,
        email: response.email,
        provider: response.provider
          ? response.provider.charAt(0).toUpperCase() + response.provider.slice(1)
          : "",
        unsubscribed: response.unsubscribed === true,
        isLoadingAccount: false,
      });
    } catch (error) {
      console.error(error);
    }
  }

  async updatePreference() {
    if (this.state.isUpdatingPreference || this.state.isLoadingAccount) return;
    const unsubscribed = !this.state.unsubscribed;
    this.setState({ isUpdatingPreference: true, preferenceError: false });
    try {
      await updateEmailPreferences({ unsubscribed });
      this.setState({ unsubscribed });
    } catch (error) {
      console.error(error);
      this.setState({ preferenceError: true });
    } finally {
      this.setState({ isUpdatingPreference: false });
    }
  }

  render() {
    return (
      <>
        <div className="bookish-input-group mt-4">
          <p className="bookish-input-label">
            <T text="Email" /> <span className="required">*</span>
          </p>
          <input
            type="text"
            className="bookish-input-field"
            name="firstName"
            value={this.state.email}
            disabled
          />
        </div>
        <div className="bookish-input-group mt-4">
          <p className="bookish-input-label">
            <T text="First Name" /> <span className="required">*</span>
          </p>
          <input
            type="text"
            className="bookish-input-field"
            name="firstName"
            value={this.state.firstName}
            disabled
          />
        </div>
        <div className="bookish-input-group mt-4">
          <p className="bookish-input-label">
            <T text="Last Name" /> <span className="required">*</span>
          </p>
          <input
            type="text"
            className="bookish-input-field"
            name="firstName"
            value={this.state.lastName}
            disabled
          />
        </div>

        <div className="bookish-input-group mt-4">
          <p className="bookish-input-label">
            <T text="Sign In Option" /> <span className="required">*</span>
          </p>
          <input
            type="text"
            className="bookish-input-field"
            name="firstName"
            value={this.state.provider}
            disabled
          />
        </div>

        {/* <div className="bookish-input-group mt-4">
          <button className="bookish-cancel-btn">Change password</button>
        </div> */}

        <div className="bookish-input-group mt-4">
          <label className="flex items-center gap-3">
            <input
              type="checkbox"
              checked={!this.state.unsubscribed}
              disabled={this.state.isUpdatingPreference || this.state.isLoadingAccount}
              onChange={() => this.updatePreference()}
            />
            <T text="Receive character emails" />
          </label>
          {this.state.isUpdatingPreference && <p role="status"><T text="Saving your preference..." /></p>}
          {this.state.preferenceError && <p role="alert"><T text="Could not update email preference. Please try again." /></p>}
        </div>
      </>
    );
  }
}

export default Personal;
